import React, { Component } from 'react';
import { Col, Row, Form, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import '../../css/chat/livechats.css';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';
import { compose } from 'redux';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { search, sort, selectInteraction } from '../../redux/interactionsSlice';
import InteractionChat from '../interactions/interactionChat';
import { faMessageLines } from '@fortawesome/pro-solid-svg-icons';
import OutgoingChat from './outgoingchat';
import InternalChat from './internalchat';
import NewChatMenu from './newchatmenu';
import NewEmail from './newemail';

class PostponedChats extends Component {

    constructor() {
        super();

        this.state = {
            showChat: false,
            showOutgoingChats: false,
            showInteralChat: false,
            showNewEmail: false
        };

        this.toggleChat = this.toggleChat.bind(this);
        this.toggleOugoingChatsModal = this.toggleOugoingChatsModal.bind(this);
        this.toggleInternalChatModal = this.toggleInternalChatModal.bind(this);
        this.toggleNewEmail = this.toggleNewEmail.bind(this);
        this.wrapperRef = React.createRef();
    }

    handleChange = e => {
        this.props.search(e.target.value);
    }

    handleSort = e => {
        this.props.sort();
    }

    toggleChat = e => {
        this.setState({ showChat: !this.state.showChat });
    }

    toggleOugoingChatsModal = e => {
        if (e)
            e.preventDefault();
        this.setState({
            showOutgoingChats: !this.state.showOutgoingChats,
            showChat: false
        });
    }

    toggleInternalChatModal = e => {
        if (e)
            e.preventDefault();
        this.setState({
            showInteralChat: !this.state.showInteralChat,
            showChat: false
        });
    }

    toggleNewEmail = e => {
        if (e)
            e.preventDefault();
        var ls = JSON.parse(localStorage.getItem("fc-logged"));
        var rcu = localStorage.getItem("faRCUser");
        var rcp = localStorage.getItem("faRCPwd");
        var roundcubeUrl = localStorage.getItem("faRC");

        var url = `${roundcubeUrl}?user=${rcu}&pass=${rcp}&tenant=${ls.tenantName}&_task=mail&_action=compose&_extwin=1&_agentId=${this.props.userId}&_faagtinbox=1`
        window.open(url, "_blank", "toolbar=no, location=no, directories=no,status=no, menubar=no, scrollbars=yes, resizable=yes, copyhistory=yes, width=1024, height=600");
        this.setState({
            showChat: false
        });
    }

    render() {
        let list = <div className=""></div>;

        if (this.props.interactions && this.props.interactions.map) {
            list = this.props.interactions.map(c => {
                return (<>
                    {
                        c.onHold &&
                        <InteractionChat key={c.id} id={c.id} name={c.name} lastMessage={c.lastMessage} unreadMessages={c.unreadMessages} channel={c.channel} date={c.date} image={c.image} onClick={this.handleClick} selected={this.props.interaction && this.props.interaction.id === c.id} group={c.group} />
                    }
                </>);
            });
        }
        return (
            <>
                <Row className='searchconversations'>
                    <Col xxl={10} lg={8}>
                        <FontAwesomeIcon className='searchicon' icon={solid("magnifying-glass")} />
                        <Form.Control className='searchinput' type="text" placeholder={this.props.t("search")} onChange={this.handleChange}></Form.Control>
                    </Col>
                    <Col xxl={1} lg={2}>
                        <Button variant='light-primary' className='filterbutton' onClick={this.handleSort}>
                            {
                                (this.props.dir !== "desc") &&
                                <FontAwesomeIcon icon={solid("arrow-up-wide-short")} />
                            }
                            {
                                (this.props.dir === "desc") &&
                                <FontAwesomeIcon icon={solid("arrow-down-wide-short")} />
                            }
                        </Button>
                    </Col>
                    <Col xxl={1} lg={2}>
                        <OverlayTrigger
                            placement="right"
                            delay={{ show: 250, hide: 400 }}
                            overlay={<Tooltip style={{ position: "fixed" }}>
                                {this.props.t("newmessage")}
                            </Tooltip>}>
                            <Button ref={this.wrapperRef} variant='light-primary' className='filterbutton' onClick={this.toggleChat}>
                                <FontAwesomeIcon icon={faMessageLines} />
                            </Button>
                        </OverlayTrigger>

                    </Col>
                </Row>
                {
                    (this.props.interactions && this.props.interactions.length > 0) &&
                    <div className='chatslist'>{list}</div>
                }
                {
                    (!this.props.interactions || this.props.interactions.length === 0) &&

                    <div className='d-flex flex-column flex-center nochats'>
                        <div className="fs-1 text-center">Fidelity</div>
                        <div className="fs-4 text-muted text-center">{this.props.t("noactivechats")}</div>
                        <div className='nochatsimg'></div>
                    </div>
                }

                <NewChatMenu invoker={this.wrapperRef} toggleChat={this.toggleChat} show={this.state.showChat} toggleOugoingChatsModal={this.toggleOugoingChatsModal} toggleInternalChatModal={this.toggleInternalChatModal} toggleNewEmail={this.toggleNewEmail}></NewChatMenu>
                <OutgoingChat show={this.state.showOutgoingChats} toggleModal={this.toggleOugoingChatsModal}></OutgoingChat>
                <InternalChat show={this.state.showInteralChat} toggleModal={this.toggleInternalChatModal}></InternalChat>
                <NewEmail show={this.state.showNewEmail} toggleModal={this.toggleNewEmail}></NewEmail>

            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        interactions: state.interaction.searchResult,
        interaction: state.interaction.current,
        dir: state.interaction.sort,
        userId: state.agent.userId
    };
};


export default compose(connect(mapStateToProps, { search, sort, selectInteraction }), withTranslation())(PostponedChats);